export default __webpack_public_path__ + "static/media/cloud-1.d6b8498b.webp";